/**
 * Personal Information Data
 * Contains personal details, bio, contact information
 */

import type { PersonalInfo } from '@/types';

export const personalInfo: PersonalInfo = {
  name: "ASHRAF ALI",
  title: "Software Engineer & AI Enthusiast",
  email: "ashrafal@buffalo.edu",
  phone: "+1-716-292-9592",
  linkedin: "https://www.linkedin.com/in/ashraf8ila/",
  github: "https://github.com/ashraf8ila",
  portfolio: "https://ashraf8ila.github.io/react-portfolio",
  bio: "Experienced Software Development Engineer with a strong background in full-stack development, AI/ML, and DevOps. Skilled in C#, Python, React, Azure DevOps, Jenkins, and various testing frameworks. Currently pursuing a Master's degree in Computer Science and Engineering, with a focus on cutting-edge technologies and methodologies.",
  location: "Austin, Texas",
  status: "Available for opportunities"
};

